export function buildParticipantJoinUrl(
  projectId: string,
  scriptId: string,
  origin: string = window.location.origin,
): string {
  const base = origin.replace(/\/$/, "");
  return `${base}/j/${encodeURIComponent(projectId)}/${encodeURIComponent(scriptId)}`;
}
